import { AbilityBuilder, createMongoAbility } from "@casl/ability"

import { getRegisteredPolicies } from "./registry"
import type { AclContext, AppAbility } from "./types"


export const buildAbility = (ctx: AclContext): AppAbility => {
  const builder = new AbilityBuilder<AppAbility>(createMongoAbility)

  const { can } = builder

  if (ctx.roles.includes("owner") || ctx.roles.includes("admin")) {
    can("manage", "all")
  }

  for (const define of getRegisteredPolicies()) {
    define(builder, ctx)
  }

  return builder.build()
}

